import { Component, Input, OnInit, signal } from '@angular/core';
import { StorageService } from '../../../services/storage.service';

@Component({
  selector: 'app-dismissable-info-banner',
  templateUrl: './dismissable-info-banner.component.html',
  styleUrls: ['./dismissable-info-banner.component.scss'],
  standalone: false,
  // Cerrado, el host no ocupa lugar: el espaciado de abajo solo existe con el banner visible.
  host: { '[class.is-hidden]': '!visible()' },
})
export class DismissableInfoBannerComponent implements OnInit {
  @Input() titleKey = '';
  @Input() textKey = '';
  @Input() icon = 'information-circle-outline';
  @Input() storageKey = '';
  /** Una sola línea: título en negrita inline + texto + X (mockup del vendedor). */
  @Input() compact = false;

  readonly visible = signal(true);

  constructor(private storageService: StorageService) {}

  async ngOnInit() {
    if (!this.storageKey) return;
    const dismissed = await this.storageService.get(this.storageKey);
    if (dismissed !== null) {
      this.visible.set(dismissed);
    }
  }

  async dismiss() {
    this.visible.set(false);
    if (this.storageKey) {
      await this.storageService.set(this.storageKey, false);
    }
  }
}
